export default {
  formName: "",
  accessionNumber: "",
  lastName: "",
  firstName: "",
  gender: "",
  dob: "",
  nationalId: "",
  subjectNumber: "",
  initialSampleCondition: "",
  sampleType: "",
  testDate: "",
  analysisMethod: "",
  testName: "",
  collectionDate: "",
  recievedDate: "",
  sampleStatusType: "",
  analysisStatus: "",

  testResult: [
    {
      accessionNumber: "",
      analysisId: "",
      analysisMethod: "",
      analysisStatusId: "",
      childReflex: "",
      considerRejectReason: "",
      defaultResultValue: "",
      dictionaryResults: [],
      displayResultAsLog: "",
      enumResultType: "",
      failedValidation: "",
      forceTechApproval: "",
      hasQualifiedResult: "",
      initialSampleCondition: "",
      isGroupSeparator: "",
      isModified: "",
      lowerAbnormalRange: "",
      lowerNormalRange: "",
      multiSelectResultValues: "",
      nationalId: "",
      nextVisitDate: "",
      nonconforming: "",
      normal: "",
      normalRange: "",
      notIncludedInWorkplan: "",
      note: "",
      pastNotes: "",
      patientInfo: "",
      patientName: "",
      qualifiedDictionaryId: "",
      qualifiedResultId: "",
      qualifiedResultValue: "",
      rawResultDisplayType: "",
      readOnly: "",
      receivedDate: "",
      refer: "",
      referralCanceled: "",
      referralId: "",
      referralItem: "",
      referralReasonId: "",
      referredOut: "",
      reflexGroup: "",
      reflexJSONResult: "",
      reflexParentGroup: "",
      rejectReasonId: "",
      rejected: "",
      remarks: "",
      remove: "",
      removed: "",
      reportable: "",
      result: "",
      resultDisplayType: "",
      resultId: "",
      resultLimitId: "",
      resultType: "",
      resultValue: "",
      sampleGroupingNumber: "",
      sampleSource: "",
      sampleType: "",
      sequenceAccessionNumber: "",
      sequenceNumber: "",
      servingAsTestGroupIdentifier: "",
      shadowReferredOut: "",
      shadowRejected: "",
      shadowResultValue: "",
      showSampleDetails: "",
      siblingReflexKey: "",
      significantDigits: "",
      expandedUncertainty: "",
      coverageFactor: "",
      technician: "",
      technicianSignatureId: "",
      testDate: "",
      testId: "",
      testKit1InventoryId: "",
      testKitId: "",
      testKitInactive: "",
      testKitInventoryId: "",
      testMethod: "",
      testName: "",
      testSortOrder: "",
      thisReflexKey: "",
      unitsOfMeasure: "",
      upperAbnormalRange: "",
      upperNormalRange: "",
      userChoiceReflex: "",
      valid: "",
    },
  ],

  methods: [
    {
      id: "",
      value: "",
    },
  ],
};
